import {FunctionComponent} from "react";
import StepObjectType from "./components/steps/StepObjectType";
import StepJewelleryMaterial from "./components/steps/StepJewelleryMaterial";
import StepCoinBarMaterial from "./components/steps/StepCoinBarMaterial";
import StepWatchBrand from "./components/steps/watch/StepWatchBrand";
import StepWatchModel from "./components/steps/watch/StepWatchModel";
import StepWatchReference from "./components/steps/watch/StepWatchReference";
import StepAdditionalInfo from "./components/steps/StepAdditionalInfo";
import StepPhoto from "./components/steps/StepPhoto";
import StepAdditionalDisposal from "./components/steps/StepAdditionalDisposal";
import StepContactData from "./components/steps/contact/StepContactData";
import StepShippingType from "./components/steps/StepShippingType";
import StepPickUpInfo from "./components/steps/contact/StepPickUpInfo";
import StepSummary from "./components/steps/summary/StepSummary";
import StepConfirmation from "./components/steps/StepConfirmation";
import StepContactDataMobile1 from "./components/steps/contact/StepContactDataMobile1";
import StepContactDataMobile2 from "./components/steps/contact/StepContactDataMobile2";
import StepPayment from "./components/steps/StepPayment";
import {NavigationProps} from "./slideRouter/navigationHook";

export enum Step {
    OBJECT_TYPE = "object_type",
    JEWELLERY_MATERIAL = "jewellery_material",
    COIN_BAR_MATERIAL = "coin_bar_material",
    WATCH_BRAND = "watch_brand",
    WATCH_MODEL = "watch_model",
    WATCH_REF = "watch_ref",
    ADD_INFO = "additional_info",
    PHOTO = "photo",
    ADD_DISPOSAL = "additional_disposal",
    CONTACT_INFO = "contact_info",
    CONTACT_INFO_MOBILE_1 = "contact_info_mobile_1",
    CONTACT_INFO_MOBILE_2 = "contact_info_mobile_2",
    PAYMENT = "payment",
    SHIPPING_TYPE = "info_type",
    SHIPPING_INFO = "info_info",
    SUMMARY = "summary",
    CONFIRMATION = "confirmation"
}

type WizardStepRouterType = { [key in Step]: FunctionComponent<NavigationProps> };

export const wizardMap: WizardStepRouterType = {
    [Step.OBJECT_TYPE]: StepObjectType,
    [Step.JEWELLERY_MATERIAL]: StepJewelleryMaterial,
    [Step.COIN_BAR_MATERIAL]: StepCoinBarMaterial,
    [Step.WATCH_BRAND]: StepWatchBrand,
    [Step.WATCH_MODEL]: StepWatchModel,
    [Step.WATCH_REF]: StepWatchReference,
    [Step.ADD_INFO]: StepAdditionalInfo,
    [Step.PHOTO]: StepPhoto,
    [Step.ADD_DISPOSAL]: StepAdditionalDisposal,
    [Step.CONTACT_INFO]: StepContactData,
    [Step.CONTACT_INFO_MOBILE_1]: StepContactDataMobile1,
    [Step.CONTACT_INFO_MOBILE_2]: StepContactDataMobile2,
    [Step.SHIPPING_TYPE]: StepShippingType,
    [Step.SHIPPING_INFO]: StepPickUpInfo,
    [Step.SUMMARY]: StepSummary,
    [Step.CONFIRMATION]: StepConfirmation,
    [Step.PAYMENT]: StepPayment
};
